import { FC, ReactNode } from 'react';
import AppFormControl from './AppFormControl';
import AppNumberInput from 'presentation/components/shared/fields/AppNumberInput';
import { NumberInputProps } from '@chakra-ui/react';

interface Props extends Omit<NumberInputProps, 'name'>, FormFieldProps {
  postfix?: ReactNode;
}

const FormNumberInput: FC<Props> = ({
  label,
  helperText,
  postfix,
  ...props
}) => {
  return (
    <AppFormControl name={props.name} label={label} helperText={helperText}>
      <AppNumberInput {...props} postfix={postfix} />
    </AppFormControl>
  );
};

export default FormNumberInput;
